import { render, staticRenderFns } from "./ConfurmKitRemove.vue?vue&type=template&id=16f31403&scoped=true&"
import script from "./ConfurmKitRemove.vue?vue&type=script&lang=js&"
export * from "./ConfurmKitRemove.vue?vue&type=script&lang=js&"
import style0 from "./ConfurmKitRemove.vue?vue&type=style&index=0&id=16f31403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f31403",
  null
  
)

export default component.exports